module.exports = __webpack_public_path__ + "img/steps-footprint.c3aae123.png";